import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Common/Loader";
import { makeDefaultPaymentMethod } from "../Redux/Slice/PaymentMethod/MakeDefaultPaymentMethodSlice";
import { ErrorModel } from "./ErrorModel";
import moment from "moment";

const SelectCardModal = ({ handleCancel, changePlanByPaymentMethod }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const { paymentMethodListData } = useSelector((s) => s?.paymentMethods);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({
    visible: false,
    message: "",
  });

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({
        visible: false,
        message: "",
      });
      if (typeof callback == "function") {
        callback();
      }
    }, 2000);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(makeDefaultPaymentMethod(selectedCard?.id));
      setIsLoading(false);
      if (
        makeDefaultPaymentMethod.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        changePlanByPaymentMethod();
      } else {
        showErrorMessage(result?.payload?.error?.message);
      }
    } catch (error) {
      setIsLoading(false);
      showErrorMessage(error?.message);
    }
  };

  const data = useMemo(() => {
    if (
      paymentMethodListData?.data &&
      Array.isArray(paymentMethodListData?.data)
    ) {
      return paymentMethodListData?.data.map((item) => {
        return {
          ...item,
          maskedCardNumber: `****-****-****-${item?.last4 ?? ""}`,
          cardExpiryDate: `${item?.expMonth}/${moment(
            item?.expYear,
            "YYYY"
          ).format("YY")}`,
        };
      });
    }
    return [];
  }, [paymentMethodListData]);

  return isLoading ? (
    <Loader />
  ) : errorModal.visible ? (
    <ErrorModel message={errorModal.message} />
  ) : (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header ">
            <h1 className="modal__header--title">Select Card</h1>
          </div>
          <div className="modal__body">
            <div className="createFormGrid">
              <div className="tableWrap" style={{ padding: 0 }}>
                <div
                  className="tableContainer"
                  style={{
                    border: "1px solid #EAECF0",
                    borderRadius: "15px",
                  }}
                >
                  <table className="table">
                    <tbody>
                      {data && data.length > 0 ? (
                        data.map((rowItem, rowIndex) => {
                          return (
                            <tr
                              key={`${rowItem?.id}-${rowIndex}`}
                              onClick={() => setSelectedCard(rowItem)}
                              style={{
                                borderBottomWidth:
                                  rowIndex == data.length - 1 ? 0 : 1,
                                borderBottomStyle: "solid",
                                borderBottomColor: "#EAECF0",
                              }}
                            >
                              <th>
                                <div
                                  className="form__radio__option"
                                  style={{
                                    display: "block",
                                    backgroundColor: "transparent",
                                    marginBottom: 0,
                                  }}
                                >
                                  <input
                                    type="radio"
                                    checked={rowItem?.id == selectedCard?.id}
                                    id={`cardRadio-${rowItem?.id}`}
                                    className="form__radio__input"
                                  />
                                  <label
                                    className="form__radio__label"
                                    for={`cardRadio-${rowItem?.id}`}
                                  ></label>
                                </div>
                              </th>
                              <td>
                                <div className="cellText">
                                  <span
                                    className="cellText__dark"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    ****-****-****-
                                    <span>{rowItem?.last4}</span>
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="cellText">
                                  <span className="cellText__dark">
                                    {rowItem?.brand}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="cellText">
                                  <span className="cellText__dark">
                                    {rowItem?.cardExpiryDate}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={4}>
                            <div className="no-data">No Cards Found!</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={handleCancel}>
                Cancel
              </button>
              <button
                disabled={!selectedCard}
                className="btn btn__primary"
                onClick={handleSubmit}
              >
                Proceed To Pay
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default SelectCardModal;
